import { useMemo } from "react";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { genericArticleFooterQuery$data } from "~/queries/__generated__/genericArticleFooterQuery.graphql";

export const useTracking = () => {
  const trackImpression = (aiEngineRecommendId: string, entityIds: string[]) => {
    sendGATracking({
      action: `PS_Topic/inHouse/${aiEngineRecommendId}/Impression`,
      category: "Top Picks Bottom",
      label: entityIds.join(","),
    });
  };

  const trackClick = (aiEngineRecommendId: string, entityId: string) => {
    sendGATracking({
      action: `PS_Topic/inHouse/${aiEngineRecommendId}/Click`,
      category: "Top Picks Bottom",
      label: entityId,
    });
  };

  return {
    trackClick,
    trackImpression,
  };
};

type Articles = genericArticleFooterQuery$data["articles"]["edges"];
export type ArticleItem = Articles[number] & { index: number };

export const useDesktopRows = (articles: Articles) => {
  const rows = useMemo(() => {
    const rowItemCounts = [2, 3, 4, 4];
    const items = [...articles];
    const rows: Array<{ items: ArticleItem[] }> = [];
    for (const rowItem of rowItemCounts) {
      const processedItems = articles.length - items.length;
      const rowItems = items
        .splice(0, rowItem)
        .map((item, index) => ({ ...item, index: processedItems + index + 1 }));
      if (rowItems.length < rowItem) break;
      rows.push({ items: rowItems });
    }
    return rows;
  }, [articles]);

  return rows;
};
